import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import OverOns from "./pages/OverOns";
import Diensten from "./pages/Diensten";
import Pakketreizen from "./pages/Pakketreizen";
import BudgetReizen from "./pages/BudgetReizen";
import PopulaireReizen from "./pages/PopulaireReizen";
import Groepsreizen from "./pages/Groepsreizen";
import RondreizenTool from "./pages/RondreizenTool";
import Contact from "./pages/Contact";
import AlgemeneVoorwaarden from "./pages/AlgemeneVoorwaarden";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/over-ons" element={<OverOns />} />
          <Route path="/diensten" element={<Diensten />} />
          <Route path="/maatwerkreizen" element={<Pakketreizen />} />
          <Route path="/pakketreizen" element={<Pakketreizen />} />
          <Route path="/budget-reizen" element={<BudgetReizen />} />
          <Route path="/populaire-reizen" element={<PopulaireReizen />} />
          <Route path="/groepsreizen" element={<Groepsreizen />} />
          <Route path="/rondreizen-tool" element={<RondreizenTool />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
